import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import vSelect from 'vue-select'
import Fuse from 'fuse.js'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faPlusCircle,
	faEye,
	faEyeSlash,
	faEdit,
} from '@fortawesome/free-solid-svg-icons'

import ModalConfirm from '@/components/edit/ModalConfirm/index.vue'
import Loader from '@/components/Loader/index.vue'
import MessageError from '@/components/edit/MessageError/index.vue'
import ManageArraySecondaryNumber from '@/components/edit/ManageArraySecondaryNumber/index.vue'

import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import Control from '@/helpers/control'
import api from '@/helpers/fetch'

import ManageArray from '@/components/edit/ManageArray/index.vue'
import InputPortal from '@/components/edit/InputPortal/index.vue'

library.add(faTrashAlt, faPlusCircle, faEye, faEyeSlash, faEdit)

// interface Company {
// 	name: string
// 	cnpj: string
// }
@Component({
	components: {
		Loader,
		vSelect,
		MessageError,
		ModalConfirm,
		ManageArraySecondaryNumber,
		ManageArray,
		InputPortal,
	},
	mixins: [validationMixin],
})
export default class TableTrialDetail extends Vue {
	@Prop({ default: 0, type: Number }) trialId!: number
	@Prop({ default: undefined, type: Object }) mainTrial
	var1 = 0
	loading = true
	success = false
	error = ''
	savedSelectValue = ''
	optionsLooseChange = ['Possível', 'Provável', 'Remota']
	secondaryNumberOptions = [
		{ name: '' },
		{ name: 'AGRESP' },
		{ name: 'RESP' },
		{ name: 'AGREXT' },
		{ name: 'RE' },
		{ name: 'Processo Administrativo' },
		{ name: 'Cumprimento de sentença' },
		{ name: 'Outro' },
	]

	now = new Date()

	currentTrial: any = {
		clientPosition: '',
		closed: '',
		currentCourt: '',
		currentSituationDate: '',
		currentSituation: {},
		dangerExposition: '',
		decision1Instance: '',
		decision2Instance: '',
		decisionCamaraSuperior: '',
		decisionCoisaJulgada: '',
		decisionImplementation: '',
		deleted: '',
		distributionDate: '',
		historicalValue: '',
		id: 0,
		infractionNumber: '',
		mainTrial: null,
		movements: [],
		oposingPart1: {},
		oposingPart2: {},
		oposingPart3: {},
		oposingPart4: {},
		oposingPart5: {},
		oposingPart6: {},
		processNumber: '',
		showTimeline: '',
		// status: '',
		subjectObs: '',
		// renewedValue: '',
		subjects: [],
		group: {
			id: null,
		},
	}

	insert = {
		subject: {
			id: '',
			loosingChance: this.optionsLooseChange[3],
			loading: false,
		},
		client: {
			id: '',
			loading: false,
		},
		movement: {
			loading: false,
			text: '',
			date: '', // new Date(),
			visible: true,
		},
	}

	infractionDescription = 'N° Auto de infração'
	isInfractionNumber = true

	options = {
		status: [
			'Ativo',
			'Sobrestado',
			'Trânsito em julgado favorável',
			'Trânsito em julgado favorável parcial',
			'Trânsito em julgado desfavorável',
			'Habilitação de crédito',
			'Desistência',
			'Substabelecido',
			'Arquivado',
		],
		states: [
			'SP',
			'RJ',
			'MG',
			'AC',
			'AL',
			'AP',
			'AM',
			'BA',
			'CE',
			'DF',
			'ES',
			'GO',
			'MA',
			'MT',
			'MS',
			'PA',
			'PB',
			'PR',
			'PE',
			'PI',
			'RN',
			'RS',
			'RO',
			'RR',
			'SC',
			'SE',
			'TO',
		],
		liminares: [
			'Oculto',
			'Em branco',
			'Deferida',
			'Parcialmente deferida',
			'Indeferida',
			'Desistência',
		],
		decisions: [
			'Oculto',
			'Favorável',
			'Desfavorável',
			'Parcialmente favorável',
		],
		coisaJulgada: ['Oculto', 'Formal', 'Material', 'Formal e material'],
		mainTrial: [] as any[],
		parts: [] as any[],
		clients: [] as any[],
		varas: [] as any[],
		subjects: [] as any[],
		systems: [] as any[],
		situations: [] as any[],
		lawsuitTypes: [] as any[],
		courthouses: [] as any[],
		clientsByName: {},
	}

	get courtsOptions() {
		return this.$store.state.courts.courtsList
	}

	clientsLoading = true
	clientsById = {}
	modalSaving = false
	modalLoading = true
	errorMessage = ''
	mask = '##.###.###/####-##'
	companiesSuccess = false
	companiesPopulated = false

	data() {
		return {
			companies: [],
		}
	}

	@Validations()
	validations() {
		return {
			group: {},
			companies: {
				$each: {
					name: {
						required,
					},
					CNPJOrCPF: {},
				},
			},
		}
	}

	async switchInfractionNumber(shouldToggle) {
		if (shouldToggle) {
			this.isInfractionNumber = !this.isInfractionNumber
			this.onInput('isInfractionNumber', this.isInfractionNumber, null)
		}

		const newInfractionDescription = this.isInfractionNumber
			? 'N° Auto de Infração'
			: 'Nº PER/DCOMP'
		this.infractionDescription = newInfractionDescription
	}

	async openCompanyModal() {
		this.$bvModal.show('modal-create-company')

		const clients: any[] = []

		this.clientsById = []

		this.options.clients.forEach((client: any) => {
			clients.push(client.id)
		})

		const resp = await api.post('/api/clients/check', { clients })

		if (resp.ok) {
			if (resp.data) {
				resp.data.forEach((element) => {
					const clientId = element.client_id
					this.clientsById[clientId] = true
				})
			}
		} else {
			this.errorMessage = resp.error
		}
		this.modalLoading = false
	}

	async deleteCompany(clientId, start) {
		this.errorMessage = ''

		this.$data.companies.splice(start, 1)

		if (clientId) {
			const resp = await api.delete('/api/clients', {
				clientId: clientId,
			})

			if (resp.ok) {
				this.$bvToast.toast('Deletado com sucesso', {
					title: 'Novas empresas',
					variant: 'success',
					noCloseButton: false,
					noAutoHide: true,
					toaster: 'b-toaster-top-center',
				})

				this.loadClientsOptions()
			} else {
				this.errorMessage = resp.error
			}
		}
	}

	async saveCompany(e) {
		e.preventDefault()

		if (this.$v.companies.$invalid) {
			return
		}

		this.modalSaving = true
		this.errorMessage = ''

		const companiesSave = JSON.parse(JSON.stringify(this.$data.companies))

		companiesSave.forEach((company) => {
			if (company.CNPJOrCPF) {
				company.CNPJOrCPF = company.CNPJOrCPF.replace(/\D/g, '')
			}
		})

		const resp = await api.post(
			'/api/clients/' +
				this?.currentTrial?.group[0]?.group?.id +
				'/groups',
			{ clients: companiesSave },
		)

		if (resp.ok) {
			this.companiesSuccess = true
			this.loadClientsOptions()
		} else {
			this.errorMessage = resp.error
		}

		this.modalSaving = false
	}

	formatCNPJ(cnpj) {
		if (cnpj) {
			return cnpj?.replace(
				/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
				'$1.$2.$3/$4-$5',
			)
		}

		return ''
	}

	onInputCompany(e) {
		if (this.$data.companies.length !== 0) {
			const debouncedChange = this.control.debounce(
				this.saveCompany,
				2000,
			)
			debouncedChange(e)
		}
	}

	control = new Control()

	mounted() {
		this.loadPartsOptions()
		// this.loadVarasOptions()
		this.loadSituationsOptions()
		this.loadSystemsOptions()
		this.loadSubjectsOptions()
		this.loadLawsuitTypesOptions()
		this.loadCourthouses()

		this.onTrialIdChange()

		this.$store.dispatch('fetchCourts')
	}

	async loadCourthouses() {
		const res = await api.get('/api/courthouses')
		this.options.courthouses = []
		this.options.courthouses.push(...res.data)
	}

	decisionsKey = 0
	async loadTrial() {
		const res = await api.get('/api/trials-adm/' + this.trialId)

		if (res.ok) {
			this.isInfractionNumber = res.data.isInfractionNumber
			await this.switchInfractionNumber(false)
			// res.data.system = res.data.system ? res.data.system.id : ''
			res.data.mainTrial = res.data.mainTrial ? res.data.mainTrial.id : ''
			// res.data.group = res.data.group[0].group

			res.data.subjects.push({
				id: null,
				name: '',
				subjectObsSugestion: null,
			})

			// res.data.subjects = res.data.subjects.map((item) => {
			// 	item.loading = false
			// 	return item
			// })
			// res.data.movements = res.data.movements.map((item) => {
			// 	item.loading = false
			// 	return item
			// })
			// res.data.clients = res.data.clients.map((item) => {
			// 	item.client.loading = false
			// 	return item
			// })
			if (res.data.currentCourt === null) res.data.currentCourt = ''
			if (res.data.currentSituation === null) {
				res.data.currentSituation = {}
			}
			// if (res.data.originVara === null) res.data.originVara = {}
			// if (res.data.originVara === null) res.data.originVara = {}
			// if (res.data.depositOrWarranty === null) {
			// 	res.data.depositOrWarranty = {
			// 		id: null,
			// 		type: '',
			// 		amount: '',
			// 		dueDate: '',
			// 	}
			// }
			if (res.data.oposingPart1 === null) {
				res.data.oposingPart1 = { id: null, loading: false }
			}
			if (res.data.oposingPart2 === null) {
				res.data.oposingPart2 = { id: null, loading: false }
			}
			if (res.data.oposingPart3 === null) {
				res.data.oposingPart3 = { id: null, loading: false }
			}
			if (res.data.oposingPart4 === null) {
				res.data.oposingPart4 = { id: null, loading: false }
			}
			if (res.data.oposingPart5 === null) {
				res.data.oposingPart5 = { id: null, loading: false }
			}
			if (res.data.oposingPart6 === null) {
				res.data.oposingPart6 = { id: null, loading: false }
			}

			Object.assign(this.currentTrial, res.data)

			this.decisionsKey++
		}
	}

	@Watch('trialId')
	async onTrialIdChange() {
		if (!this.trialId) return
		this.loading = true
		this.$emit('loading', this.loading)
		await this.loadTrial()
		this.loadClientsOptions()
		this.loadMainTrialOptions()
		this.$nextTick(() => {
			this.loading = false
			this.$emit('loading', this.loading)
		})
	}

	formatDate(dateString) {
		const [year, month, date] = dateString.split('-')

		return `${date}/${month}/${year}`
	}

	loadPDF(clientId) {
		fetch('/api/relatorio-adm/' + clientId)
			.then((res) => res.blob())
			.then((blob) => {
				const file = window.URL.createObjectURL(blob)
				const pdfFrame: any = this.$refs['pdf-frame']
				pdfFrame.src = file
			})
	}

	updateMovementDebouncedChange(movement) {
		const debouncedChange = this.control.debounce(() => {
			this.updateMovement(movement, false)
		}, 1000)
		debouncedChange()
	}

	async updateMovement(movement, updateVisibleState) {
		setLoading(movement, true)

		if (updateVisibleState) {
			movement.visible = !movement.visible
		}

		this.currentTrial.movements.forEach((m) => {
			if (m.id === movement.id) {
				m = { ...m, visible: movement.visible }
			}
		})

		const data = { ...movement }
		delete data.loading

		const res = await api.put('/api/trials/movements', data)

		if (res.ok) {
			setLoading(movement, false)
			this.var1++
			this.$emit('success', true)
			this.$emit('error', false)
		} else {
			this.$emit('success', false)
			this.$emit('error', res.msg)
		}
	}

	async removeMovement(movement: any, index) {
		setLoading(movement, true)
		const res = await api.delete(
			'/api/trials-adm/' + this.currentTrial.id + '/movements',
			{
				movementId: movement.id,
			},
		)
		setLoading(movement, false)
		if (res.ok) this.currentTrial.movements.splice(index, 1)
	}

	async insertMovement() {
		this.insert.movement.loading = true
		const res = await api.post(
			'/api/trials-adm/' + this.currentTrial.id + '/movements',
			{
				text: this.insert.movement.text,
				date: this.insert.movement.date,
				visible: this.insert.movement.visible,
			},
		)
		this.insert.movement.loading = false
		this.insert.movement.text = ''
		this.insert.movement.date = new Date().toISOString()
		this.insert.movement.visible = true

		if (res.ok) {
			this.currentTrial.movements = []
			this.currentTrial.movements.push(...res.data)
		}
	}

	addPart() {
		if (this.currentTrial.oposingPart1.id === null) {
			this.currentTrial.oposingPart1.id = 0
		} else if (this.currentTrial.oposingPart2.id === null) {
			this.currentTrial.oposingPart2.id = 0
		} else if (this.currentTrial.oposingPart3.id === null) {
			this.currentTrial.oposingPart3.id = 0
		} else if (this.currentTrial.oposingPart4.id === null) {
			this.currentTrial.oposingPart4.id = 0
		} else if (this.currentTrial.oposingPart5.id === null) {
			this.currentTrial.oposingPart5.id = 0
		} else if (this.currentTrial.oposingPart6.id === null) {
			this.currentTrial.oposingPart6.id = 0
		}
	}

	async removePart(number) {
		const partProp = 'oposingPart' + number
		this.currentTrial[partProp].loading = true
		await this.save(partProp, null, null)
		this.currentTrial[partProp].loading = false
		this.currentTrial[partProp].id = null
	}

	async onUpdate(array, reference) {
		if (!reference) reference = ''

		let manageArrayComponent2
		if (reference) {
			manageArrayComponent2 = this.$refs[reference]
		}

		manageArrayComponent2.setLoading(true)

		const newArray = array.map((name) => {
			if (typeof name === 'string') {
				return this.options.clientsByName[name]
			}

			return name
		})

		const res = await api.post(
			'/api/trials-adm/' + this.currentTrial.id + '/clients',
			newArray,
		)

		if (res.ok) {
			this.insert.client.id = ''
			this.currentTrial.clients.push({ loading: false, ...res.data })
			manageArrayComponent2.setLoading(false)
			manageArrayComponent2.setSuccess(true)
		}
	}

	async deleteClient(clientRelation, index) {
		setLoading(clientRelation.client, true)
		const res = await api.delete(
			'/api/trials/' + this.currentTrial.id + '/clients',
			{
				clientRelationId: clientRelation.id,
			},
		)
		if (res.ok) this.currentTrial.clients.splice(index, 1)
		setLoading(clientRelation.client, false)
	}

	cleanArrayClients(clients) {
		return clients.map((client) => {
			return client.client
		})
	}

	newArrayClientsByName(clients) {
		return clients.map((client) => {
			return client.name
		})
	}

	handleSubjectInput(subjectRelation, index, value) {
		if (value) {
			this.insertSubject(value.id)
		} else {
			this.deleteSubject(subjectRelation.id, index)
		}
	}

	async insertSubject(subjectId) {
		const res = await api.post(
			'/api/trials-adm/' + this.currentTrial.id + '/subjects',
			{
				subjectId: subjectId,
			},
		)

		if (res.ok) {
			res.data.push({})
			this.currentTrial.subjects = res.data
		}
	}

	async deleteSubject(id, index) {
		// setLoading(subject, true)
		const res = await api.delete(
			'/api/trials-adm/' + this.currentTrial.id + '/subjects',
			{
				subjectsRelationId: id,
			},
		)
		// setLoading(subject, false)
		if (res.ok) {
			this.currentTrial.subjects.splice(index, 1)
			if (this.currentTrial.subjects.length === 0) {
				this.currentTrial.subjects.push({})
			}
		}
	}

	onInput(name, value, relation?) {
		const debouncedChange = this.control.debounce(() => {
			this.save(name, value, relation)
		}, 1000)
		debouncedChange()
	}

	onSelectInput(name, prop, relation?) {
		const propArray = prop.split('.')
		const key = propArray[0]
		const index = propArray[1]
		const nested = propArray[2]

		const secondTernary = index
			? this.currentTrial[key][index]
			: this.currentTrial[key]

		const value = nested
			? this.currentTrial[key][index][nested]
			: secondTernary

		if (!value && prop !== 'mainTrial' && !prop.includes('oposingPart')) {
			if (relation) {
				this.currentTrial[key][index][nested] = this.savedSelectValue
			} else if (nested) {
				this.currentTrial[key][nested] = this.savedSelectValue
			} else this.currentTrial[key] = this.savedSelectValue

			return
		}

		this.save(name, value, relation)
		/*
		const debouncedChange = this.control.debounce(() => {
		}, 1000)
		debouncedChange()
		*/
	}

	async save(name, value, relation) {
		if (!this.currentTrial.id) return
		this.$emit('saving', true)

		const newGroup = {}
		newGroup[name] = value
		if (relation) Object.assign(newGroup, relation)

		const result = await api.post(
			'/api/trials-adm/' + this.currentTrial.id,
			newGroup,
		)

		this.$emit('saving', false)

		if (result.ok) {
			this.$emit('success', true)
			this.$emit('error', false)
		} else {
			this.$emit('success', false)
			this.$emit('error', result.msg)
		}
	}

	async loadMainTrialOptions() {
		const res = await api.get(
			'/api/trials-adm/' + this.currentTrial.id + '/mainTrialOptions',
		)
		if (res.ok) {
			// this.options.mainTrial.length = 0
			// res.data = res.data.map((item) => {
			// 	const mask = '#######-##.####.#.##.####'
			// 	let final = ''
			// 	let charCount = 0
			// 	for (let n = 0; n < mask.length; n++) {
			// 		if (mask[n] === '#') {
			// 			final += item.name[charCount]
			// 			charCount++
			// 		} else {
			// 			final += mask[n]
			// 		}
			// 	}

			// 	item.name = final
			// 	return item
			// })

			this.options.mainTrial.push(...res.data)
		}
	}

	async loadPartsOptions() {
		const res = await api.get('/api/parts')
		if (res.ok) {
			this.options.parts.length = 0

			if (res.data && res.data.length) {
				this.options.parts.push(...res.data)
			}
		}
	}

	async loadClientsOptions() {
		const res = await api.get(
			'/api/groups/' +
				this?.currentTrial?.group[0]?.group?.id +
				'/clients',
		)

		if (res.ok) {
			this.$data.companies = []
			this.options.clients.length = 0
			this.options.clients.push(...res.data)
			const companies = res.data.map((company) => {
				company.CNPJOrCPF = this.formatCNPJ(company.CNPJOrCPF)
				return company
			})

			this.$data.companies.push(...companies)

			this.options.clients.forEach((client) => {
				if (client) {
					this.options.clientsByName[client.name] =
						this.options.clientsByName[client.name] || client
				}
			})
			this.clientsLoading = false
		}
	}

	// async loadVarasOptions() {
	// 	const res = await api.get('/api/courts')
	// 	if (res.ok) {
	// 		this.options.varas.length = 0

	// 		this.options.varas.push(...res.data)
	// 	}
	// }

	async loadSubjectsOptions() {
		const res = await api.get('/api/subjects')
		if (res.ok) {
			this.options.subjects.length = 0

			if (res.data && res.data.length) {
				this.options.subjects.push(...res.data)
			}
		}
	}

	async loadSystemsOptions() {
		const res = await api.get('/api/systems')
		if (res.ok) {
			this.options.systems.length = 0

			if (res.data && res.data.length) {
				this.options.systems.push(...res.data)
			}
		}
	}

	async loadSituationsOptions() {
		const res = await api.get('/api/situations-adm')

		if (res.ok) {
			this.options.situations.length = 0

			this.options.situations.push(...res.data)
		}
	}

	async loadLawsuitTypesOptions() {
		const res = await api.get('/api/lawsuit-types')

		if (res.ok && res.data) {
			this.options.lawsuitTypes.length = 0

			this.options.lawsuitTypes.push(...res.data)
		}
	}

	fuseSearch(options, search) {
		const fuse = new Fuse(options, {
			keys: ['name'],
			shouldSort: true,
			ignoreLocation: true,
		})

		return search.length
			? fuse.search(search).map(({ item }) => item)
			: options
	}

	subjectObsError = ''
	subjectObsInput() {
		this.subjectObsError = ''
		const value = this.currentTrial.subjectObs

		if (value?.includes('{') || value?.includes('}')) {
			this.subjectObsError =
				'Erro: Observação de Assunto não pode conter "{" ou "}". Não falta substituir algum valor nesse texto?'
		} else {
			this.onInput('subjectObs', this.currentTrial.subjectObs, null)
		}
	}

	addedFiles: any[] = []
	filesStatus: any[] = []
	uploading = false
	async onFileInput($event) {
		$event.preventDefault()
		const filesInput: any = $event.target
		const files = filesInput.files
		for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
			const file = files[fileIndex]
			const name = file.name
			const formattedSize = formatBytes(file.size)

			this.addedFiles.push({
				file,
				name,
				size: formattedSize,
			})
		}

		await this.uploadFiles()
	}

	fileInputKey = 0
	async uploadFiles() {
		const form: any = this.$refs.fileForm
		if (form) {
			const formData = new FormData(form)
			const resp = await fetch('/api/decision-files/upload', {
				method: 'POST',
				body: formData,
			})

			if (resp && resp.ok) {
				await this.loadTrial()
				this.fileInputKey++
				this.addedFiles = []
			}
		}
	}

	keyDecisionFile = 0
	async onDecisionFileInput($event, field, file) {
		setTimeout(async () => {
			const fileId = file.id

			const saveFile = {
				id: fileId,
			}

			if (field === 'visible') {
				saveFile[field] = $event
			} else {
				saveFile[field] = file[field]
			}

			this.$emit('saving', true)

			const res = await api.put('/api/decision-files', {
				saveFile,
				cnj: this.currentTrial.cnj,
				file,
			})

			if (res.ok) {
				const returnedFile = res.file
				const files = this.currentTrial.decisionFiles
				const found = files.find((file) => file.id === fileId)
				const index = files.indexOf(found)
				const newFound = { ...found, ...returnedFile }
				Vue.set(this.currentTrial.decisionFiles, index, newFound)
				this.keyDecisionFile++
			}

			this.$emit('saving', false)
		}, 0)
	}

	async downloadFile($event, file) {
		const googleDriveId = file.googleDriveId
		const res = await fetch(
			'/api/decision-files/download?googleDriveId=' + googleDriveId,
			{
				headers: {
					Accept: 'application/pdf',
					'Content-Type': 'application/pdf',
				},
				method: 'GET',
				credentials: 'include',
			},
		)

		const headers = [...res.headers]
		const contentDispositionHeader = headers.find(
			(array) => array[0] === 'content-disposition',
		)
		if (contentDispositionHeader) {
			const fileName = contentDispositionHeader[1].replace(
				'attachment; filename=',
				'',
			)

			const blob = await res.blob()
			const newBlob = new Blob([blob])
			const blobUrl = window.URL.createObjectURL(newBlob)

			const link: any = document.createElement('a')
			link.href = blobUrl
			link.setAttribute('download', fileName)
			document.body.appendChild(link)

			if (link) {
				link.click()
				link.parentNode.removeChild(link)
				window.URL.revokeObjectURL(blobUrl)
			}
		}
	}

	fileToDelete: any = null
	setFileToDelete(file) {
		const that = this as any
		const $bvModal = that.$bvModal

		if ($bvModal) {
			$bvModal.show('modal-confirm-delete-decision-files')
			this.fileToDelete = file
		}
	}

	deleting = false
	async deleteFile(file) {
		this.deleting = true
		const res = await fetch('/api/decision-files/' + file.id, {
			method: 'DELETE',
			credentials: 'include',
		})

		this.deleting = false
		if (res.ok) {
			const found = this.currentTrial.decisionFiles.find(
				(f) => f.id === file.id,
			)
			const index = this.currentTrial.decisionFiles.indexOf(found)

			if (index >= 0) {
				this.currentTrial.decisionFiles.splice(index, 1)
				this.keyDecisionFile++

				const that = this as any
				const $bvModal = that.$bvModal
				$bvModal.hide('modal-confirm-delete-decision-files')
			}
		}
	}

	async updateSecondaryNumber($event, reference?) {
		const trialId = this.currentTrial.id
		const list = $event.map((item) => {
			return {
				number: item.number,
				type: item.type,
				trial_id: trialId,
			}
		})

		const resp = await api.post(
			`/api/trials/${trialId}/secondary-numbers`,
			list,
		)

		const component: any = this.$refs[reference]
		if (resp.ok && component.setSuccess && component?.setLoading) {
			component.setLoading(false)
			component.setSuccess(true)
		}
	}
}

function formatBytes(bytes, decimals = 2) {
	if (!+bytes) return '0 Bytes'

	const k = 1024
	const dm = decimals < 0 ? 0 : decimals
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

	const i = Math.floor(Math.log(bytes) / Math.log(k))

	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

function setLoading(movement, value) {
	movement.loading = value
}

// function toggleVisibility(movement) {
// 	movement.visible = !movement.visible
// }
// function addRecord() {
// 	throw new Error('Function not implemented.')
// }
// function resetForm() {
// 	throw new Error('Function not implemented.')
// }
